/// <Reference path="./types/global.d.ts" />
/** @jsx jsx */
import { jsx } from "@emotion/core"
import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { ErrorBoundary } from "./components/ErrorBoundary"

// Ensure skeem is available globally
import "./utils/skeem"

const VideoEmbedPage = React.lazy(() =>
  import("./pages/front/VideoEmbedPage").then(mod => ({ default: mod.VideoEmbedPage })),
)

const WebsiteRouter = React.lazy(() =>
  import("./WebsiteRouter").then(mod => ({ default: mod.WebsiteRouter })),
)

ReactDOM.render(<App />, document.getElementById("root"))

function App() {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <ErrorBoundary>
          <Switch>
            <Route path="/video/embed/:id" component={VideoEmbedPage} />
            <Route path="/" component={WebsiteRouter} />
          </Switch>
        </ErrorBoundary>
      </BrowserRouter>
    </Suspense>
  )
}
